<template>
    <div class="tyn-root academy-player">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="ap">
                        <VideoViewer v-if="idVideoSelecionado !== null"
                                     :key="'vv-' + idVideoSelecionado"
                                     :id-video="idVideoSelecionado"
                                     :id-treinamento="idTrilha"
                                     :descricao-trilha="trilha && trilha.dsTreinamento"
                                     :titulo-trilha="trilha && trilha.nmTreinamento"
                                     :autor-trilha="trilha && trilha.nmAutor"
                                     :total-sessoes="secoes.length"
                                     :total-aulas="totalAulas"
                                     :aula-anterior="aulaAnterior"
                                     :proxima-aula="proximaAula"
                                     :secao-numero="aulaAtual ? aulaAtual.secaoNumero : 0"
                                     :secao-titulo="aulaAtual ? aulaAtual.secaoTitulo : ''"
                                     :percentual="percentual"
                                     :total-concluidas="totalConcluidas"
                                     :minutos-totais="minutosTotais"
                                     :minutos-restantes="minutosRestantes"
                                     :aulas-restantes="aulasRestantes"
                                     :proximas-aulas="proximasAulas"
                                     :secao-atual="secaoAtualResumo"
                                     :anexos="anexosAulaAtual"
                                     @atualizar-progresso="marcarConcluido"
                                     @selecionar-aula="selecionarAula"
                                     @ver-trilha="abrirDetalhesTrilha"
                                     @baixar-anexo="baixarAnexo"
                                     @aula-indisponivel="aoAulaIndisponivel" />
                        <div v-else class="ap-sem-aula">
                            <strong>{{ sessoesCarregadas ? 'Nenhuma aula disponível' : 'Carregando aulas…' }}</strong>
                            <span v-if="sessoesCarregadas">Não encontramos uma aula que possa ser aberta nesta trilha.</span>
                        </div>

                        <aside class="ap-sidebar" aria-label="Conteúdo do curso">
                            <div class="ap-sidebar-topo">
                                <div class="ap-entre">
                                    <h2 class="ap-sidebar-titulo">Conteúdo do curso</h2>
                                    <span class="ap-pct">{{ percentual }}%</span>
                                </div>
                                <div class="ap-barra"
                                     role="progressbar"
                                     :aria-valuenow="percentual"
                                     aria-valuemin="0"
                                     aria-valuemax="100">
                                    <div class="ap-barra-fill" :style="{ width: percentual + '%' }"></div>
                                </div>
                                <span class="ap-muted ap-sm">{{ totalConcluidas }} de {{ plural(totalAulas, 'aula concluída', 'aulas concluídas') }}</span>
                            </div>

                            <div class="ap-sidebar-lista">
                                <div v-for="(secao, index) in secoesVisiveis" :key="secao.idSessao" class="ap-secao">
                                    <button type="button"
                                            class="ap-secao-btn"
                                            :aria-expanded="secao.aberta ? 'true' : 'false'"
                                            :disabled="secao.vazia"
                                            @click="alternarSecao(index)">
                                        <span class="ap-secao-texto">
                                            <span class="ap-eyebrow">SEÇÃO {{ secao.numero }} · {{ secao.meta }}</span>
                                            <span class="ap-secao-titulo">{{ secao.titulo }}</span>
                                        </span>
                                        <svg v-if="!secao.vazia" class="ap-chevron" :class="{ 'is-aberto': secao.aberta }" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
                                    </button>

                                    <ol v-show="secao.aberta" class="ap-aulas">
                                        <li v-for="aula in secao.aulas" :key="aula.id">
                                            <button type="button"
                                                    class="ap-aula"
                                                    :class="{ 'is-atual': aula.id === idVideoSelecionado }"
                                                    :aria-current="aula.id === idVideoSelecionado ? 'true' : undefined"
                                                    :title="aula.titulo"
                                                    @click="selecionarAula(aula.id)">
                                                <span v-if="aula.id === idVideoSelecionado" class="ap-status ap-status--atual" aria-label="Em reprodução">
                                                    <svg viewBox="0 0 24 24" aria-hidden="true" class="is-fill"><path d="M7 4v16l13-8Z" /></svg>
                                                </span>
                                                <span v-else-if="aula.concluido" class="ap-status ap-status--ok" aria-label="Concluída">
                                                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
                                                </span>
                                                <span v-else class="ap-status ap-status--pendente" aria-label="Pendente"></span>

                                                <span class="ap-aula-texto">
                                                    <span class="ap-aula-titulo">{{ aula.numero }}. {{ aula.titulo }}</span>
                                                    <span v-if="aula.duracaoMin" class="ap-muted ap-sm">{{ formatarDuracao(aula.duracaoMin) }}</span>
                                                </span>
                                            </button>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </div>

        <ModalTrilha :trilhaSelecionada="trilhaSelecionada"
                     :mostrar-ir-para-trilha="false"
                     @fechar="trilhaSelecionada = null" />
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import axios from 'axios'
    import { urlApi, avisoToast } from '@/config/global'
    import VideoViewer from "@/components/SollAcademy/VideoViewer.vue";
    import ModalTrilha from '@/components/SollAcademy/ModalTrilha.vue'

    export default {
        components: { Header, VideoViewer, ModalTrilha },
        name: "SollAcademyVisualizador",
        data() {
            return {
                trilha: null,
                idTrilha: null,
                idVideoSelecionado: null,
                anotacoes: "",
                secoes: [],
                trilhaSelecionada: null,
                sessoesCarregadas: false,
                selecaoAutomatica: false,
                aulasDescartadas: [],
            };
        },

        computed: {
            aulasPlanas() {
                const lista = [];
                let numero = 0;
                this.secoes.forEach((secao, indiceSecao) => {
                    (secao.aulas || []).forEach(aula => {
                        numero += 1;
                        lista.push({
                            ...aula,
                            numero,
                            secaoNumero: indiceSecao + 1,
                            secaoTitulo: secao.titulo,
                            duracaoMin: this.minutosDe(aula.duracaoSeg),
                        });
                    });
                });
                return lista;
            },
            indiceAtual() {
                return this.aulasPlanas.findIndex(aula => aula.id === this.idVideoSelecionado);
            },
            aulaAtual() {
                return this.aulasPlanas[this.indiceAtual] || null;
            },
            aulaAnterior() {
                return this.aulasPlanas[this.indiceAtual - 1] || null;
            },
            proximaAula() {
                return this.aulasPlanas[this.indiceAtual + 1] || null;
            },
            totalAulas() {
                return this.aulasPlanas.length;
            },
            totalConcluidas() {
                return this.aulasPlanas.filter(aula => aula.concluido).length;
            },
            percentual() {
                if (!this.totalAulas) return 0;
                return Math.round((this.totalConcluidas / this.totalAulas) * 100);
            },
            minutosTotais() {
                return this.aulasPlanas.reduce((total, aula) => total + (aula.duracaoMin || 0), 0);
            },
            minutosRestantes() {
                return this.aulasPlanas.reduce((total, aula) => total + (aula.concluido ? 0 : (aula.duracaoMin || 0)), 0);
            },
            proximasAulas() {
                if (this.indiceAtual < 0) return [];
                return this.aulasPlanas.slice(this.indiceAtual + 1, this.indiceAtual + 4);
            },
            aulasRestantes() {
                if (this.indiceAtual < 0) return 0;
                return Math.max(0, this.totalAulas - this.indiceAtual - 1);
            },
            secaoAtualResumo() {
                if (!this.aulaAtual) return null;
                const secao = this.secoesVisiveis.find(item => item.numero === this.aulaAtual.secaoNumero);
                if (!secao) return null;
                return {
                    numero: secao.numero,
                    concluidas: secao.aulas.filter(aula => aula.concluido).length,
                    total: secao.aulas.length,
                };
            },
            anexosAulaAtual() {
                const aula = this.aulasPlanas[this.indiceAtual];
                return aula?.anexos || [];
            },
            secoesVisiveis() {
                const porId = {};
                this.aulasPlanas.forEach(aula => { porId[aula.id] = aula; });
                return this.secoes.map((secao, index) => {
                    const aulas = (secao.aulas || []).map(aula => porId[aula.id] || aula);
                    const minutos = aulas.reduce((total, aula) => total + (aula.duracaoMin || 0), 0);
                    return {
                        ...secao,
                        numero: index + 1,
                        aulas,
                        vazia: aulas.length === 0,
                        meta: aulas.length
                            ? this.plural(aulas.length, 'aula', 'aulas') + (minutos ? ` · ${this.formatarDuracao(minutos)}` : '')
                            : 'Em breve',
                    };
                });
            },
        },

        methods: {
            selecionarAula(id) {
                this.selecaoAutomatica = false;
                this.idVideoSelecionado = id;
                const indice = this.secoes.findIndex(secao => secao.aulas?.some(aula => aula.id === id));
                if (indice >= 0) this.secoes[indice].aberta = true;
            },

            aulaReproduzivel(aula) {
                const url = String(aula?.urlRecurso || '').trim();
                if (!aula?.id || !url) return false;
                if (String(aula.dsFormato || '').toLowerCase() === 'youtube') return !!this.extrairYoutubeId(url);
                return true;
            },

            extrairYoutubeId(url) {
                try {
                    const endereco = new URL(url);
                    return endereco.searchParams.get('v')
                        || (endereco.hostname.includes('youtu.be') ? endereco.pathname.slice(1) : '')
                        || (endereco.pathname.startsWith('/shorts/') ? endereco.pathname.split('/')[2] : '')
                        || (endereco.pathname.startsWith('/embed/') ? endereco.pathname.split('/')[2] : '');
                } catch (e) {
                    const encontrado = String(url).match(/(?:v=|youtu\.be\/|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{11})/);
                    return encontrado ? encontrado[1] : '';
                }
            },

            abrirPrimeiraAulaValida() {
                const candidatas = this.aulasPlanas.filter(item => this.aulaReproduzivel(item) && !this.aulasDescartadas.includes(Number(item.id)));
                const aula = candidatas.find(item => !item.concluido) || candidatas[0];
                if (!aula) {
                    this.idVideoSelecionado = null;
                    this.selecaoAutomatica = false;
                    this.sessoesCarregadas = true;
                    return;
                }
                this.selecaoAutomatica = true;
                this.idVideoSelecionado = aula.id;
                this.secoes.forEach(secao => {
                    secao.aberta = (secao.aulas || []).some(item => item.id === aula.id);
                });
                this.sessoesCarregadas = true;
            },

            aoAulaIndisponivel(id) {
                const atual = Number(id);
                if (!this.selecaoAutomatica) return;
                if (atual !== Number(this.idVideoSelecionado)) return;
                if (!this.aulasDescartadas.includes(atual)) this.aulasDescartadas.push(atual);
                this.abrirPrimeiraAulaValida();
            },

            alternarSecao(indice) {
                this.secoes[indice].aberta = !this.secoes[indice].aberta;
            },

            abrirDetalhesTrilha() {
                if (this.trilha?.idTreinamento) this.trilhaSelecionada = { ...this.trilha };
            },

            plural(quantidade, singular, pluralTxt) {
                return `${quantidade} ${quantidade === 1 ? singular : pluralTxt}`;
            },

            minutosDe(segundos) {
                const total = Number(segundos) || 0;
                if (total <= 0) return 0;
                return Math.max(1, Math.round(total / 60));
            },

            formatarDuracao(minutos) {
                if (!minutos) return '—';
                if (minutos < 60) return `${minutos} min`;
                const horas = Math.floor(minutos / 60);
                const resto = minutos % 60;
                return resto ? `${horas}h ${resto}min` : `${horas}h`;
            },

            getTrilha() {
                let $this = this;
                axios.get(`${urlApi}/SollAcademy/GetTreinamento/${$this.idTrilha}`)
                    .then(res => {
                        if (res.data.success) {

                            $this.trilha = res.data.data.item;
                            $this.getSessoes($this.trilha.idTreinamento);
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar trilha:", err);
                        avisoToast("Erro ao carregar trilha!", "warning");
                    });
            },

            getSessoes(idTreinamento) {
                let $this = this;
                axios.get(`${urlApi}/SollAcademy/GetSessoes`, { params: { idTreinamento } })
                    .then(res => {
                        if (res.data.success) {
                            const sessoes = res.data.data.rows.map(r => r.item);
                            const promessasRecursos = sessoes.map(sessao =>
                                axios.get(`${urlApi}/SollAcademy/GetRecursosSessoes`, { params: { idSessao: sessao.idSessao } })
                                    .then(resp => {
                                        sessao.recursos = resp.data.success
                                            ? resp.data.data.rows.map(r => r.item)
                                            : [];
                                    })
                                    .catch(() => {
                                        sessao.recursos = [];
                                    })
                            );

                            Promise.all(promessasRecursos).then(async () => {
                                $this.sessoes = sessoes;
                                $this.montarSecoes();
                                await $this.getProgressoClientePorTreinamento();
                                $this.abrirPrimeiraAulaValida();
                                $this.getAnexosDasAulas();
                            });
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao carregar seções:", err);
                        avisoToast("Erro ao carregar seções!", "warning");
                    });
            },

            montarSecoes() {
                this.aulasDescartadas = [];
                this.secoes = this.sessoes.map(sessao => ({
                    idSessao: sessao.idSessao,
                    titulo: sessao.nmSessao,
                    aberta: false,
                    aulas: (sessao.recursos || []).map(recurso => ({
                        id: recurso.idRecursoSessao,
                        titulo: recurso.nmRecurso,
                        duracaoSeg: recurso.nrDuracao,
                        urlRecurso: recurso.urlRecurso,
                        dsFormato: recurso.dsFormato,
                        concluido: false,
                        anexos: [],
                    }))
                }));

            },

            async getProgressoClientePorTreinamento() {
                try {
                    const res = await axios.get(`${urlApi}/SollAcademy/GetProgressosClientes`, {
                        params: { idTreinamento: this.idTrilha }
                    });

                    if (res.data.success) {
                        const concluidosSet = new Set(
                            res.data.data.rows
                                .map(r => r.item)
                                .filter(it => it.flConcluido === true)
                                .map(it => Number(it.idRecursoSessao))
                        );

                        this.secoes.forEach(secao => {
                            secao.aulas.forEach(aula => {
                                aula.concluido = concluidosSet.has(Number(aula.id));
                            });
                        });
                    }
                } catch (err) {
                    console.error("Erro ao buscar progresso:", err);
                }
            },

            async getAnexosDasAulas() {
                const promessas = [];

                this.secoes.forEach(secao => {
                    secao.aulas.forEach(aula => {
                        const promessa = axios.get(`${urlApi}/SollAcademy/GetAnexosRecursos`, {
                            params: { idRecursoSessao: aula.id }
                        }).then(res => {
                            if (res.data.success && res.data.data.rows.length > 0) {
                                aula.anexos = res.data.data.rows.map(r => r.item);
                                aula.temAnexo = true;
                            }
                        }).catch(() => { });
                        promessas.push(promessa);
                    });
                });

                await Promise.all(promessas);
            },

            baixarAnexo(idAnexoRecurso, nomeArquivo) {
                axios.get(`${urlApi}/SollAcademy/DownloadAnexoRecurso/${idAnexoRecurso}`, {
                    responseType: 'blob'
                })
                    .then((response) => {
                        const blob = new Blob([response.data], { type: response.headers['content-type'] });
                        const url = window.URL.createObjectURL(blob);

                        const link = document.createElement('a');
                        link.href = url;

                        const disposition = response.headers['content-disposition'];
                        let fileName = nomeArquivo || 'anexo';

                        if (disposition && disposition.includes('filename=')) {
                            fileName = disposition.split('filename=')[1].replace(/['"]/g, '');
                        }

                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch((error) => {
                        console.error("Erro ao baixar arquivo:", error);
                        avisoToast("Erro ao baixar arquivo!", "error");
                    });
            },

            marcarConcluido(idVideo) {
                this.secoes.forEach(secao => {
                    secao.aulas.forEach(aula => {
                        if (aula.id === idVideo) {
                            aula.concluido = !aula.concluido;
                        }
                    });
                });
            }
        },

        mounted() {
            this.idTrilha = this.$route.query.idTrilha;
            if (this.idTrilha) {
                this.getTrilha();
            } else {
                avisoToast("ID da trilha não informado.", "danger");
            }
        },

    };
</script>

<style scoped>
    .academy-player {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .academy-player .tyn-content,
    .academy-player .tyn-main,
    .academy-player .tyn-section {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    .ap {
        --ap-primaria: #1463ff;
        --ap-primaria-hover: #0b4fd6;
        --ap-primaria-suave: #eff4ff;
        --ap-primaria-texto: #1d4ed8;
        --ap-sucesso: #059669;
        --ap-sucesso-texto: #047857;
        --ap-sucesso-suave: #ecfdf5;
        --ap-perigo: #b91c1c;
        --ap-texto: #0f172a;
        --ap-texto-2: #334155;
        --ap-texto-3: #475569;
        --ap-muted: #64748b;
        --ap-borda: #e2e8f0;
        --ap-borda-suave: #eef2f7;
        --ap-fundo: #f8fafc;
        --ap-superficie: #ffffff;
        --ap-sidebar-w: 380px;

        display: grid;
        grid-template-columns: minmax(0, 1fr) var(--ap-sidebar-w);
        height: var(--content-full-height, calc(100vh - 65px));
        min-height: 0;
        overflow: hidden;
        background: var(--ap-fundo);
        color: var(--ap-texto);
        font-family: 'Poppins', system-ui, sans-serif;
    }

    .ap-sem-aula {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-width: 0;
        padding: 32px;
        text-align: center;
        color: var(--ap-muted);
        font-size: 14px;
    }

    .ap-sem-aula strong {
        color: var(--ap-texto-2);
        font-size: 16px;
    }

    .ap svg {
        width: 18px;
        height: 18px;
        fill: none;
        stroke: currentColor;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
        flex-shrink: 0;
    }

    .ap svg.is-fill {
        fill: currentColor;
        stroke: none;
    }

    .ap-muted { color: var(--ap-muted); }
    .ap-sm { font-size: 12px; }
    .ap-eyebrow { font-size: 11px; font-weight: 600; letter-spacing: 0.08em; color: var(--ap-muted); }
    .ap-entre { display: flex; align-items: center; justify-content: space-between; gap: 12px; }

    .ap-sidebar {
        height: 100%;
        min-height: 0;
        display: flex;
        flex-direction: column;
        background: var(--ap-superficie);
        border-left: 1px solid var(--ap-borda);
    }

    .ap-sidebar-topo {
        padding: 20px 20px 16px;
        border-bottom: 1px solid var(--ap-borda-suave);
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .ap-sidebar-titulo { margin: 0; font-size: 16px; font-weight: 700; }
    .ap-pct { font-size: 13px; font-weight: 600; color: var(--ap-sucesso-texto); }
    .ap-barra { height: 6px; background: var(--ap-borda); border-radius: 999px; overflow: hidden; }
    .ap-barra-fill { height: 100%; background: var(--ap-sucesso); border-radius: 999px; transition: width 0.3s ease; }

    .ap-sidebar-lista { flex: 1 1 auto; min-height: 0; overflow-y: auto; padding: 8px 0; }
    .ap-secao { border-bottom: 1px solid var(--ap-borda-suave); }

    .ap-secao-btn {
        width: 100%;
        min-height: 56px;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 20px;
        border: 0;
        background: none;
        font: inherit;
        text-align: left;
        cursor: pointer;
        color: inherit;
    }

    .ap-secao-btn:hover:not(:disabled) { background: var(--ap-fundo); }
    .ap-secao-btn:disabled { cursor: default; }
    .ap-secao-btn:disabled .ap-secao-titulo { color: var(--ap-muted); }
    .ap-secao-texto { display: flex; flex-direction: column; gap: 2px; flex-grow: 1; min-width: 0; }
    .ap-secao-titulo { font-size: 14px; font-weight: 600; color: var(--ap-texto); }
    .ap-chevron { color: var(--ap-muted); transition: transform 0.2s; }
    .ap-chevron.is-aberto { transform: rotate(180deg); }

    .ap-aulas {
        list-style: none;
        margin: 0;
        padding: 0 12px 10px;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .ap-aula {
        width: 100%;
        min-height: 48px;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 10px;
        border: 0;
        border-radius: 10px;
        background: transparent;
        font: inherit;
        text-align: left;
        cursor: pointer;
        color: inherit;
    }

    .ap-aula:hover { background: var(--ap-fundo); }
    .ap-aula.is-atual { background: #eff4ff; }
    .ap-aula-texto { display: flex; flex-direction: column; gap: 1px; flex-grow: 1; min-width: 0; }
    .ap-aula-titulo {
        font-size: 13px;
        color: #1e293b;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .ap-aula.is-atual .ap-aula-titulo { color: #1d4ed8; font-weight: 600; }

    .ap-status {
        width: 22px;
        height: 22px;
        flex-shrink: 0;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
    }
    .ap-status--ok { background: var(--ap-sucesso); color: #fff; }
    .ap-status--ok svg { width: 12px; height: 12px; stroke-width: 3.2; }
    .ap-status--atual { background: var(--ap-primaria); color: #fff; }
    .ap-status--atual svg { width: 10px; height: 10px; }
    .ap-status--pendente { border: 2px solid #cbd5e1; }

    .ap button:focus-visible {
        outline: 2px solid var(--ap-primaria);
        outline-offset: 2px;
    }

    @media (max-width: 1024px) {
        .ap {
            grid-template-columns: minmax(0, 1fr);
            height: auto;
            min-height: var(--content-full-height, calc(100vh - 65px));
            overflow: visible;
        }

        .ap-sidebar {
            height: auto;
            border-left: 0;
            border-top: 1px solid var(--ap-borda);
        }

        .ap-sidebar-lista { overflow: visible; }
    }

    [data-bs-theme="dark"] .ap {
        --ap-primaria: #3b82f6;
        --ap-primaria-hover: #60a5fa;
        --ap-primaria-suave: rgba(59, 130, 246, 0.16);
        --ap-primaria-texto: #93c5fd;
        --ap-sucesso: #34d399;
        --ap-sucesso-texto: #6ee7b7;
        --ap-sucesso-suave: rgba(52, 211, 153, 0.14);
        --ap-perigo: #fca5a5;
        --ap-texto: #f1f5f9;
        --ap-texto-2: #cbd5e1;
        --ap-texto-3: #94a3b8;
        --ap-muted: #94a3b8;
        --ap-borda: rgba(148, 163, 184, 0.22);
        --ap-borda-suave: rgba(148, 163, 184, 0.14);
        --ap-fundo: #0b1120;
        --ap-superficie: #1e293b;
    }

    [data-bs-theme="dark"] .ap-aula.is-atual { background: rgba(59, 130, 246, 0.16); }
    [data-bs-theme="dark"] .ap-aula-titulo { color: #e2e8f0; }
    [data-bs-theme="dark"] .ap-aula.is-atual .ap-aula-titulo { color: #93c5fd; }
    [data-bs-theme="dark"] .ap-status--pendente { border-color: #475569; }
</style>
